// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a867bdd7c0--wrapper--J7rBS","phone":"a867bdd7c0--phone--c9BWA","item-wrapper":"a867bdd7c0--item-wrapper--ouUmt","tooltip-icon":"a867bdd7c0--tooltip-icon--VqiDx"};